import { ExperimentClient } from '@amplitude/experiment-js-client';

import { useIdentityStore } from './store';

export const getFeatureValueFn =
	(client?: ExperimentClient) =>
	(flag: string): boolean => {
		if (!client) {
			return false;
		}

		return client.variant(flag)?.value === 'on';
	};

export const enabled = (flag: string) => {
	const client = useIdentityStore.getState().experimentClient;

	return getFeatureValueFn(client)(flag);
};
